export default function Error() {
  return (
    <div>
      <h1>Oops! Page not found!</h1>
    </div>
  );
}
